/**
 * Auto-detect input type and diagram kind from pasted text.
 */

import type { InputFormat, DiagramType } from './types';

export interface DetectResult {
  format: InputFormat;
  /** For mermaid inputs, the specific diagram type */
  diagramType?: DiagramType;
}

const MERMAID_PATTERNS: Array<{ pattern: RegExp; type: DiagramType }> = [
  { pattern: /^\s*flowchart\b/m, type: 'flowchart' },
  { pattern: /^\s*graph\b/m, type: 'flowchart' },
  { pattern: /^\s*classDiagram\b/m, type: 'class' },
  { pattern: /^\s*stateDiagram\b/m, type: 'state' },
  { pattern: /^\s*erDiagram\b/m, type: 'er' },
  { pattern: /^\s*mindmap\b/m, type: 'mindmap' },
  { pattern: /^\s*gantt\b/m, type: 'gantt' },
  { pattern: /^\s*timeline\b/m, type: 'timeline' },
];

export function detectInput(text: string): DetectResult {
  const trimmed = text.trim();

  // Check for draw.io XML
  if (trimmed.startsWith('<mxfile') || trimmed.startsWith('<mxGraphModel')) {
    return { format: 'drawio-xml' };
  }

  // Check mermaid diagram types
  for (const { pattern, type } of MERMAID_PATTERNS) {
    if (pattern.test(trimmed)) {
      return { format: type, diagramType: type };
    }
  }

  // Default to flowchart
  return { format: 'flowchart', diagramType: 'flowchart' };
}
